module.exports = __webpack_public_path__ + "static/media/video-player.5e820b33.svg";